export default __webpack_public_path__ + "static/media/IBMEyeHide.c7b5c6ba.svg";